module.exports = __webpack_public_path__ + "img/10_47.6d130921.png";